
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {rules} from "@/auxillary/rules";
import {currentUserModule, rolesModule} from "@/store";
import DataFieldCache from "@/models/data.field.cache";
import {MdbsCore} from "@/api/tsclient";
import EventReportDeactivationDto = MdbsCore.EventReportDeactivationDto;
import EventReportClient = MdbsCore.EventReportClient;

@Component({})
export default class EventReportDeactivationDialog extends Vue {
  @Prop({required: true})
  eventReportField: DataFieldCache | null;

  @Prop({required: true})
  dialogVisible: boolean | null;

  private reasonChoice = "";
  private otherReason = "";

  private userName = "";
  private password = "";

  saving = false;
  valid: boolean = false;
  rules: any = rules;
  message = "";

  get loading() {
    return false;
  }

  get reason(){
    if (this.reasonChoice == "other")
      return this.otherReason;
    return this.reasonChoice;
  }

  @Watch('eventReportField', {immediate: true})
  async onVisitChange(eventReportField: DataFieldCache | null) {
    if (eventReportField == null) {
      return;
    }

    Vue.nextTick(() => {
      this.form?.validate();
    });
  }

  @Watch('dialogVisible', {immediate: true})
  async onDialogVisibleChange(visible: boolean) {
    if (!visible) return;

    this.message = "";
    await this.prePopulateUserName();
  }

  get form(): Vue & { validate: () => boolean } {
    return this.$refs.form as Vue & { validate: () => boolean }
  }

  async save() {
    if (!this.eventReportField) return;

    try {
      this.saving = true;

      const erClient = new EventReportClient()
      const result =  await erClient.deactivateEventReport(this.eventReportField.id, new EventReportDeactivationDto({
        userName: this.userName,
        password: this.password,
        reason: this.reason
      }))

      if (result.success){
        this.reasonChoice = "";
        this.otherReason = "";
        this.$emit('save');
      } else {
        this.message = result.message ?? "";
      }
    } finally {
      this.saving = false;
      this.userName = "";
      this.password = "";
    }
  }

  async cancel() {
    this.$emit('cancel');
    this.reasonChoice = "";
    this.otherReason = "";
    this.userName = "";
    this.password = "";
  }

  get currentUser() {
    return currentUserModule.user;
  }

  async mounted() {
  }

  private async prePopulateUserName() {
    const user = this.currentUser;
    if (user?.role?.id == null || user?.userName == null) return;

    if(currentUserModule.isNtdUser)
      return;

    const role = await rolesModule.getRoleById(user.role.id);

    if (role?.identifier?.toLowerCase() == "physician") {
      this.userName = user.userName;
    }
  }
}
